import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String, delay: { type: Number, default: 1500 } }

  declare urlValue: string
  declare delayValue: number

  connect() {
    if (this.urlValue) {
      setTimeout(() => {
        this.navigateToResults()
      }, this.delayValue)
    }
  }

  private navigateToResults(): void {
    document.addEventListener("turbo:load", this.scrollToResults, { once: true })
    Turbo.visit(this.urlValue)
  }

  private scrollToResults = (): void => {
    // Wait for DOM paint to complete before scrolling
    requestAnimationFrame(() => {
      setTimeout(() => {
        const target = document.getElementById("importation-results")
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" })
        }
      }, 100)
    })
  }
}
